import React, { useEffect, useRef } from "react";
import { Container } from "react-bootstrap";
import { setHeading } from "../../accounts/account.actions";
import { connect } from "react-redux";
import { baseURL, headers } from "../../../../global/api";
import { UpdateUserRes, deleteUserRes } from "./user.actions";
import jsPDF from "jspdf";
import MaterialTable from "material-table";
import { PDFHeader } from "../../../../global/globalFunctions";
import moment from "moment";
// import TaskAltIcon from '@mui/icons-material/TaskAlt';
// import BlockIcon from '@mui/icons-material/Block';
// import _ from "lodash";


const ViewUser = (props) => {
  const tableRef = useRef();
  function updateTableQuery() {
    tableRef.current.onQueryChange()
  };

  useEffect(() => {
    props.setHeading("User List")
  }, []);

  return (
    <>
      <Container fluid>
        <MaterialTable
          tableRef={tableRef}
          style={{ zIndex: 0 }}
          title="User List"
          columns={[
            { title: "Company", field: "restaurant.restaurantName", editable: 'never' },
            { title: "Business Locaton", field: "wareHouseId.businessName", editable: 'never' },
            { title: "Role", field: "role", editable: 'never' },
            { title: "User Name", field: "userName" },
            { title: "Password", field: "hash", render: rowData => '********' },
            { title: "Last Login", field: "lastLogin", render: rowData => rowData?.lastLogin ? moment(rowData?.lastLogin).format('DD-MM-YYYY') : 'Never' },
            {
              title: "User Status", field: "enable", editable: 'never',
              render: (rowData) => (
                <div
                  style={{
                    backgroundColor: rowData.enable === true ? "#9FD983" : rowData.enable === false ? "#F8B8A2" : "#f7cb74",
                    padding: "5px 16px 7px",
                    borderRadius: "10px",
                    textAlign: "center",
                    width: "max-content"
                  }}
                >
                  {rowData.enable === true ? 'Active' : 'Blocked'}
                </div>
              ),
            },
          ]}
          data={(query) =>
            new Promise((resolve, reject) => {
              let url = `${baseURL}/users/?`;
              url += "limit=" + query.pageSize;
              url += "&page=" + (query.page);
              url += "&search=" + query.search;
              fetch(url, {
                method: "GET",
                headers: headers,
              }).then((response) => response.json()).then((result) => {
                resolve({
                  data: result.data,
                  page: result.page,
                  totalCount: result.total_results,
                });
              });
            })
          }
          options={{
            actionsColumnIndex: -1,
            // filtering: true,
            exportButton: true,
            exportAllData: true,
            paging: true,
            pageSize: 50,
            emptyRowsWhenPaging: false,
            pageSizeOptions: [50, 100, 150, 200],
            headerStyle: {
              position: "sticky",
              top: 0,
              color: "#00BBBB",
              fontWeight: "550",
              onRowAdd: "none",
            },
            exportPdf: (columns, data) => {
              const unit = "pt";
              const size = "A4";
              const orientation = "portrait";
              const doc = new jsPDF(orientation, unit, size);
              PDFHeader(doc, "User Details");

              const columnTitles = columns.map(columnDef => columnDef.title);
              const pdfData = data.map((elt) => [
                elt.restaurant.restaurantName,
                elt.wareHouseId.businessName,
                elt.role,
                elt.userName,
                '********',
                elt.enable === true ? 'Active' : 'Blocked',
              ]);
              let content = {
                startY: 120,
                startX: 5,
                head: [columnTitles],
                body: pdfData,
                headStyles: { fillColor: "#2980ba", font: 'Amiri', fontSize: 10 },
                styles: { fontSize: 9 },
                theme: "grid",
              };

              doc.setFontSize(11)
              doc.setFont("Times New Roman", "Normal")
              doc.autoTable(content);

              doc.setProperties({ title: 'User Details' })
              doc.output('dataurlnewwindow')
            },
          }}
          editable={{
            onRowUpdate: (newData, oldData) =>
              new Promise((resolve) => {
                setTimeout(() => {
                  resolve();
                  props.UpdateUser(newData, oldData);
                }, 600);
              }),
            onRowDelete: (oldData) =>
              new Promise((resolve) => {
                setTimeout(() => {
                  resolve();
                  props.deleteUser(oldData._id, updateTableQuery);
                }, 600);
              }),
          }}
          actions={[
            {
              icon: 'refresh',
              tooltip: 'Refresh Data',
              isFreeAction: true,
              onClick: () => tableRef.current && tableRef.current.onQueryChange(),
            },
            // (rowData) => ({
            //   disabled: rowData.enable === false ? false : true,
            //   icon: () => <TaskAltIcon style={{ color: rowData.enable === false ? 'green' : '#cccccc' }} />,
            //   tooltip: "Active",
            //   onClick: (event, rowData) => {
            //     const status = true
            //     props.UpdateEmployeeStatusApi(status, rowData._id);
            //     tableRef.current && tableRef.current.onQueryChange();
            //   },
            // }),
            // (rowData) => ({
            //   disabled: rowData.enable === true ? false : true,
            //   icon: () => <BlockIcon style={{ color: rowData.enable === true ? '#dc3545' : '#cccccc' }} />,
            //   tooltip: "Blocked",
            //   onClick: (event, rowData) => {
            //     const status = false
            //     props.UpdateEmployeeStatusApi(status, rowData._id);
            //     tableRef.current && tableRef.current.onQueryChange();
            //   },
            // }),
          ]}
        />
      </Container>
    </>
  );
};
const mapDispatchToProps = (dispatch) => {
  return {
    deleteUser: (id) => dispatch(deleteUserRes(id)),
    UpdateUser: (newData, oldData) => dispatch(UpdateUserRes(newData, oldData)),
    setHeading: (data) => dispatch(setHeading(data))
  };
};
const mapStateToProps = (state, ownProps) => ({

});

export default connect(mapStateToProps, mapDispatchToProps)(ViewUser);